import React, { useState, useEffect } from "react";
import { Nav } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faCogs,
  faIndustry,
  faScrewdriverWrench,
  faHistory,
  faUsers,
  faFileAlt,
  faChevronDown,
  faBoxes,
  faClipboardList, // ⬅️ TAMBAHKAN INI
  faUserGear,
  faBox,
  faToolbox,
  faClipboardCheck,
  faRightFromBracket,
  faLightbulb,
} from "@fortawesome/free-solid-svg-icons";

import { useNavigate } from "react-router-dom";
import api from "../../axiosConfig";
import "./DashboardCommon.css";

const Sidebar = ({
  activeTab,
  setActiveTab,
  userRole = "maintenance",
  onLogout,
  mobileOpen,
  setMobileOpen,
}) => {
  const navigate = useNavigate();
  const [openStock, setOpenStock] = useState(false);
  const [openStockItem, setOpenStockItem] = useState(false);
  const [openStockHistory, setOpenStockHistory] = useState(false);
  const [openDataMaster, setOpenDataMaster] = useState(false);
  const [openAdminStock, setOpenAdminStock] = useState(false);
  const [openHistory, setOpenHistory] = useState(false);
  const [pendingStock, setPendingStock] = useState(0);

  // Badge jumlah permintaan stock yang menunggu persetujuan (admin only)
  useEffect(() => {
    if (userRole !== "admin") return;
    let alive = true;
    const load = async () => {
      try {
        const res = await api.get("/stock-requests/count");
        if (alive) setPendingStock(res.data?.pending || 0);
      } catch (_) {
        /* abaikan */
      }
    };
    load();
    const t = setInterval(load, 20000);
    return () => {
      alive = false;
      clearInterval(t);
    };
  }, [userRole, activeTab]);

  // Auto open dropdown berdasarkan tab aktif
  useEffect(() => {
    if (
      ["history", "historytools", "historykaizen", "historymesin"].includes(
        activeTab,
      )
    ) {
      setOpenHistory(true);
    }

    if (activeTab.startsWith("stock")) setOpenStock(true);

    if (
      activeTab === "stock-short" ||
      activeTab === "stock-long" ||
      activeTab === "stock-tools"
    ) {
      setOpenStockItem(true);
    }

    if (
      activeTab === "stock-history-stock" ||
      activeTab === "stock-history-mesin" ||
      activeTab === "stock-history-tools" ||
      activeTab === "history-kaizen"
    ) {
      setOpenStockHistory(true);
    }
  }, [activeTab]);

  const getBaseUrl = () => {
    switch (userRole) {
      case "admin":
        return "/admin-dashboard";
      case "user":
        return "/user-dashboard";
      case "maintenance":
        return "/maintenance-dashboard";
      case "teknisi":
        return "/teknisi-dashboard";
      default:
        return "/";
    }
  };

  const handleTabChange = (tab, path = null) => {
    console.log("SIDEBAR CLICK =", tab);

    setMobileOpen(false);

    setActiveTab(tab);

    const baseUrl = getBaseUrl();

    if (path) {
      navigate(`${baseUrl}/${path}`);
    } else if (tab === "overview") {
      navigate(baseUrl);
    } else {
      navigate(`${baseUrl}/${tab}`);
    }
  };

  // ---------------- MAINTENANCE ----------------
  const renderMaintenanceMenu = () => (
    <>
      <Nav.Link
        className={activeTab === "overview" ? "active" : ""}
        onClick={() => handleTabChange("overview")}
        style={{ marginTop: "-5px" }}
      >
        <FontAwesomeIcon icon={faHome} /> Dashboard
      </Nav.Link>

      <Nav.Link
        className={activeTab === "machines" ? "active" : ""}
        onClick={() => handleTabChange("machines")}
      >
        <FontAwesomeIcon icon={faCogs} /> Mesin
      </Nav.Link>

      <Nav.Link
        className={activeTab === "tools" ? "active" : ""}
        onClick={() => handleTabChange("tools")}
      >
        <FontAwesomeIcon icon={faScrewdriverWrench} /> Tools
      </Nav.Link>

      <Nav.Link
        className={activeTab === "sectors" ? "active" : ""}
        onClick={() => handleTabChange("sectors")}
      >
        <FontAwesomeIcon icon={faIndustry} /> Sektor
      </Nav.Link>

      <Nav.Link
        className={activeTab === "loan" ? "active" : ""}
        onClick={() => handleTabChange("loan")}
      >
        <FontAwesomeIcon icon={faClipboardList} /> Data Pinjam Tools
      </Nav.Link>

      <Nav.Link
        className={activeTab === "kaizen" ? "active" : ""}
        onClick={() => handleTabChange("kaizen")}
      >
        <FontAwesomeIcon icon={faClipboardList} /> Kaizen
      </Nav.Link>

      <Nav.Link
        className={activeTab === "history" ? "active" : ""}
        onClick={() => handleTabChange("history")}
      >
        <FontAwesomeIcon icon={faHistory} /> Riwayat Perbaikan
      </Nav.Link>

      <Nav.Link
        className={activeTab === "checksheet" ? "active" : ""}
        onClick={() => handleTabChange("checksheet")}
      >
        <FontAwesomeIcon icon={faClipboardCheck} /> Check Sheet
      </Nav.Link>

      {userRole === "maintenance" && renderMaintenanceStockMenu()}
    </>
  );
  const renderMaintenanceStockMenu = () => (
    <>
      <Nav.Link
        className={activeTab.startsWith("stock") ? "active" : ""}
        onClick={() => setOpenStock(!openStock)}
      >
        <FontAwesomeIcon icon={faClipboardList} /> Stock & Histori
        <FontAwesomeIcon
          icon={faChevronDown}
          className={`float-end chevron ${openStock ? "open" : ""}`}
        />
      </Nav.Link>

      <div className={`submenu-wrap ${openStock ? "open" : ""}`}>
        <div className="submenu">
          {/* STOCK ITEM */}
          <Nav.Link
            className={
              activeTab === "stock-short" ||
              activeTab === "stock-long" ||
              activeTab === "stock-tools"
                ? "active"
                : ""
            }
            onClick={() => {
              setOpenStockItem(!openStockItem);
              setOpenStockHistory(false);
            }}
          >
            <FontAwesomeIcon icon={faBoxes} /> Stock Item
            <FontAwesomeIcon
              icon={faChevronDown}
              className={`float-end chevron ${openStockItem ? "open" : ""}`}
            />
          </Nav.Link>

          <div className={`submenu-wrap ${openStockItem ? "open" : ""}`}>
            <div className="submenu nested">
              <Nav.Link
                className={activeTab === "stock-short" ? "active" : ""}
                onClick={() => handleTabChange("stock-short", "stock/short")}
              >
                Short Lifetime
              </Nav.Link>

              <Nav.Link
                className={activeTab === "stock-long" ? "active" : ""}
                onClick={() => handleTabChange("stock-long", "stock/long")}
              >
                Long Lifetime
              </Nav.Link>

              <Nav.Link
                className={activeTab === "stock-tools" ? "active" : ""}
                onClick={() => handleTabChange("stock-tools", "stock/tools")}
              >
                Tools Stock
              </Nav.Link>
            </div>
          </div>

          {/* STOCK HISTORY */}
          <Nav.Link
            className={
              activeTab === "stock-history-stock" ||
              activeTab === "stock-history-mesin" ||
              activeTab === "stock-history-tools"
                ? "active"
                : ""
            }
            onClick={() => {
              setOpenStockHistory(!openStockHistory);
              setOpenStockItem(false);
            }}
          >
            <FontAwesomeIcon icon={faHistory} /> History
            <FontAwesomeIcon
              icon={faChevronDown}
              className={`float-end chevron ${openStockHistory ? "open" : ""}`}
            />
          </Nav.Link>

          <div className={`submenu-wrap ${openStockHistory ? "open" : ""}`}>
            <div className="submenu nested">
              <Nav.Link
                className={activeTab === "history-kaizen" ? "active" : ""}
                onClick={() =>
                  handleTabChange("history-kaizen", "stock/history-kaizen")
                }
              >
                History Kaizen
              </Nav.Link>

              <Nav.Link
                className={activeTab === "stock-history-stock" ? "active" : ""}
                onClick={() =>
                  handleTabChange("stock-history-stock", "stock/history-stock")
                }
              >
                History Stock Item
              </Nav.Link>

              <Nav.Link
                className={activeTab === "stock-history-mesin" ? "active" : ""}
                onClick={() =>
                  handleTabChange("stock-history-mesin", "stock/history-mesin")
                }
              >
                History Mesin
              </Nav.Link>

              <Nav.Link
                className={activeTab === "stock-history-tools" ? "active" : ""}
                onClick={() =>
                  handleTabChange("stock-history-tools", "stock/history-tools")
                }
              >
                History Tools
              </Nav.Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  //----------------- USER -----------------------

  const renderUserMenu = () => (
    <>
      <Nav.Link
        className={activeTab === "overview" ? "active" : ""}
        onClick={() => handleTabChange("overview")}
      >
        <FontAwesomeIcon icon={faHome} /> Dashboard
      </Nav.Link>

      <Nav.Link
        className={activeTab === "machines" ? "active" : ""}
        onClick={() => handleTabChange("machines")}
      >
        <FontAwesomeIcon icon={faCogs} /> Mesin
      </Nav.Link>

      {/* ✅ MENU TOOLS */}
      <Nav.Link
        className={activeTab === "tools" ? "active" : ""}
        onClick={() => handleTabChange("tools")}
      >
        <FontAwesomeIcon icon={faScrewdriverWrench} /> Tools
      </Nav.Link>

      <Nav.Link
        className={activeTab === "checksheet" ? "active" : ""}
        onClick={() => handleTabChange("checksheet")}
      >
        <FontAwesomeIcon icon={faClipboardCheck} /> Check Sheet
      </Nav.Link>
    </>
  );

  //----------------- TEKNISI ---------------------

  const renderTeknisiMenu = () => (
    <>
      <Nav.Link
        className={activeTab === "machines" ? "active" : ""}
        onClick={() => handleTabChange("machines")}
      >
        <FontAwesomeIcon icon={faCogs} /> Mesin
      </Nav.Link>

      <Nav.Link
        className={activeTab === "tools" ? "active" : ""}
        onClick={() => handleTabChange("tools")}
      >
        <FontAwesomeIcon icon={faScrewdriverWrench} /> Tools
      </Nav.Link>

      <Nav.Link
        className={activeTab === "history" ? "active" : ""}
        onClick={() => handleTabChange("history")}
      >
        <FontAwesomeIcon icon={faHistory} /> History Perbaikan Mesin
      </Nav.Link>

      <Nav.Link
        className={activeTab === "historytools" ? "active" : ""}
        onClick={() => handleTabChange("historytools")}
      >
        <FontAwesomeIcon icon={faHistory} /> History Perbaikan Tools
      </Nav.Link>
    </>
  );

  //----------------- ADMIN ----------------------

  const renderAdminMenu = () => (
    <>
      <Nav.Link
        className={activeTab === "overview" ? "active" : ""}
        onClick={() => handleTabChange("overview")}
        style={{ marginTop: "-5px" }}
      >
        <FontAwesomeIcon icon={faHome} /> Dashboard
      </Nav.Link>

      <Nav.Link
        className={activeTab === "stock-approval" ? "active" : ""}
        onClick={() => handleTabChange("stock-approval")}
      >
        <FontAwesomeIcon icon={faClipboardCheck} /> Persetujuan Stock
        {pendingStock > 0 && (
          <span
            className="badge bg-danger float-end"
            style={{ borderRadius: "10px" }}
          >
            {pendingStock}
          </span>
        )}
      </Nav.Link>

      <Nav.Link
        onClick={() => {
          setOpenDataMaster(!openDataMaster);
          setOpenHistory(false);
          setOpenAdminStock(false);
        }}
      >
        <FontAwesomeIcon icon={faBoxes} /> Data Master
        <FontAwesomeIcon
          icon={faChevronDown}
          className={`float-end chevron ${openDataMaster ? "open" : ""}`}
        />
      </Nav.Link>

      <div className={`submenu-wrap ${openDataMaster ? "open" : ""}`}>
        <div className="submenu">
          <Nav.Link
            className={activeTab === "sectors" ? "active" : ""}
            onClick={() => handleTabChange("sectors")}
          >
            <FontAwesomeIcon icon={faIndustry} /> Sektor
          </Nav.Link>

          <Nav.Link
            className={activeTab === "machines" ? "active" : ""}
            onClick={() => handleTabChange("machines")}
          >
            <FontAwesomeIcon icon={faCogs} /> Mesin
          </Nav.Link>

          <Nav.Link
            className={activeTab === "tools" ? "active" : ""}
            onClick={() => handleTabChange("tools")}
          >
            <FontAwesomeIcon icon={faScrewdriverWrench} /> Tools
          </Nav.Link>

          <Nav.Link
            className={activeTab === "checksheet" ? "active" : ""}
            onClick={() => handleTabChange("checksheet")}
          >
            <FontAwesomeIcon icon={faClipboardCheck} /> Check Sheet Mesin
          </Nav.Link>

          <Nav.Link
            className={activeTab === "technicians" ? "active" : ""}
            onClick={() => handleTabChange("technicians")}
          >
            <FontAwesomeIcon icon={faUserGear} /> Teknisi
          </Nav.Link>
          <Nav.Link
            className={activeTab === "users" ? "active" : ""}
            onClick={() => handleTabChange("users")}
          >
            <FontAwesomeIcon icon={faUsers} /> User Management
          </Nav.Link>
        </div>
      </div>

      <Nav.Link
        className={
          [
            "history",
            "historytools",
            "historykaizen",
            "historymesin",
            "historystock",
          ].includes(activeTab)
            ? "active"
            : ""
        }
        onClick={() => {
          setOpenHistory(!openHistory);
          setOpenDataMaster(false);
          setOpenAdminStock(false);
        }}
      >
        <FontAwesomeIcon icon={faHistory} /> History
        <FontAwesomeIcon
          icon={faChevronDown}
          className={`float-end chevron ${openHistory ? "open" : ""}`}
        />
      </Nav.Link>

      <div className={`submenu-wrap ${openHistory ? "open" : ""}`}>
        <div className="submenu">
          <Nav.Link
            className={activeTab === "history" ? "active" : ""}
            onClick={() => handleTabChange("history")}
          >
            <FontAwesomeIcon icon={faCogs} /> History Mesin
          </Nav.Link>

          <Nav.Link
            className={activeTab === "historymesin" ? "active" : ""}
            onClick={() => handleTabChange("historymesin")}
          >
            <FontAwesomeIcon icon={faCogs} /> History Mesin (Per Mesin)
          </Nav.Link>

          <Nav.Link
            className={activeTab === "historytools" ? "active" : ""}
            onClick={() => handleTabChange("historytools")}
          >
            <FontAwesomeIcon icon={faFileAlt} /> History Tools
          </Nav.Link>

          <Nav.Link
            className={activeTab === "historykaizen" ? "active" : ""}
            onClick={() => handleTabChange("historykaizen")}
          >
            <FontAwesomeIcon icon={faLightbulb} /> History Kaizen
          </Nav.Link>

          <Nav.Link
            className={activeTab === "historystock" ? "active" : ""}
            onClick={() => handleTabChange("historystock")}
          >
            <FontAwesomeIcon icon={faClipboardCheck} /> History Stock Item
          </Nav.Link>
        </div>
      </div>

      {renderAdminStockMenu()}
    </>
  );
  const renderAdminStockMenu = () => (
    <>
      <Nav.Link
        className={activeTab.startsWith("stock") ? "active" : ""}
        onClick={() => {
          setOpenAdminStock(!openAdminStock);
          setOpenDataMaster(false);
          setOpenHistory(false);
        }}
      >
        <FontAwesomeIcon icon={faClipboardList} /> Stock Item
        <FontAwesomeIcon
          icon={faChevronDown}
          className={`float-end chevron ${openAdminStock ? "open" : ""}`}
        />
      </Nav.Link>

      <div className={`submenu-wrap ${openAdminStock ? "open" : ""}`}>
        <div className="submenu">
          <Nav.Link
            className={activeTab === "short" ? "active" : ""}
            onClick={() => handleTabChange("short")}
          >
            <FontAwesomeIcon icon={faBox} /> Short Lifetime
          </Nav.Link>

          <Nav.Link
            className={activeTab === "long" ? "active" : ""}
            onClick={() => handleTabChange("long")}
          >
            <FontAwesomeIcon icon={faBoxes} /> Long Lifetime
          </Nav.Link>

          <Nav.Link
            className={activeTab === "stocktools" ? "active" : ""}
            onClick={() => handleTabChange("stocktools")}
          >
            <FontAwesomeIcon icon={faToolbox} /> Stock Tools
          </Nav.Link>
        </div>
      </div>
    </>
  );

  return (
    <>
      <button
        className="mobile-menu-btn"
        onClick={() => setMobileOpen(!mobileOpen)}
      >
        ☰
      </button>

      {mobileOpen && (
        <div className="sidebar-overlay" onClick={() => setMobileOpen(false)} />
      )}

      <>
        <div className={`sidebar ${mobileOpen ? "open" : ""}`}>
          <div className="sidebar-header">
            <h3>{userRole.charAt(0).toUpperCase() + userRole.slice(1)}</h3>
          </div>

          <div className="sidebar-menu">
            <Nav className="flex-column">
              {userRole === "maintenance"
                ? renderMaintenanceMenu()
                : userRole === "user"
                  ? renderUserMenu()
                  : userRole === "teknisi"
                    ? renderTeknisiMenu()
                    : renderAdminMenu()}
            </Nav>

            <Nav.Link onClick={onLogout} className="logout-menu">
              <FontAwesomeIcon icon={faRightFromBracket} /> Logout
            </Nav.Link>
          </div>
        </div>
      </>
    </>
  );
};

export default Sidebar;
